import { render, staticRenderFns } from "./ExchangeView.vue?vue&type=template&id=32216a04"
import script from "./ExchangeView.vue?vue&type=script&lang=js"
export * from "./ExchangeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports